<template>
    <div>
      <div :class="[((whereIamFrom === 'hoverCard' && content.objecttype === 'EPGPROGRAMME') || (whereIamFrom === 'gridCard' && titleShow)) && 'bottom-18', 'Subscribe']" v-if="showLock">
        <p>{{ $t("Subscribe") }}</p>
      </div>
      <div class="lock" v-if="showLock">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          width="25"
          height="25"
          viewBox="0 0 34 34"
          style="enable-background:new 0 0 50 50"
        >
          <g>
            <path
              d="M17 1c-5 0-9 4-9 9v4c-1.7 0-3 1.3-3 3v13c0 1.7 1.3 3 3 3h18c1.7 0 3-1.3 3-3V17c0-1.7-1.3-3-3-3v-4c0-5-4-9-9-9zm10 16v13c0 .6-.4 1-1 1H8c-.6 0-1-.4-1-1V17c0-.6.4-1 1-1h18c.6 0 1 .4 1 1zm-17-3v-4c0-3.9 3.1-7 7-7s7 3.1 7 7v4z"
              fill="#ffffff"
            />
            <path
              d="M17 19c-1.7 0-3 1.3-3 3 0 1.3.8 2.4 2 2.8V27c0 .6.4 1 1 1s1-.4 1-1v-2.2c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
              fill="#ffffff"
            />
          </g>
        </svg>
      </div>
    </div>
  </template>
  
  <script>
  // import PlaybackUtilities from "@/mixins/playbackUtilities.js";
  import { mapGetters } from "vuex";
  
  export default {
    props: ["content", "whereIamFrom", "titleShow"],
    data() {
      return {
        showLock: true,
        purchaseListData: []
      };
    },
    computed: {
      ...mapGetters(["subscriberid", "availabilityList", "purchaseList", "profileid", "subscriptionList"]),
      // Computed property to filter availability based on content.availabilityset
    },
    watch: {
      subscriberid() {
        this.checkContentPlayback();
      },
      availabilityList() {
        this.checkContentPlayback();
      },
      content: {
        handler() {
          this.checkContentPlayback();
        },
        deep: true,
        immediate: true,
      },
      purchaseList(val) {
        this.purchaseListData = val;
        this.getPurchaseListCode();
      },
      subscriptionList(newVal, oldVal) {
        if(newVal) {
          this.checkContentPlayback();
        }
      }
    },
    mounted() {
      this.checkContentPlayback();
    },
    methods: {
      async checkContentPlayback() {
        if (!this.subscriberid) {
          this.showLock = true;
          return;
        }
  
        // if (this.content?.objecttype === "SERIES") {
        //   this.showLock = false;
        //   return;
        // }
  
        const isAllowed = await this.checkAvailabilityAllowsPlayback(this.content);
        this.showLock = !isAllowed;
      },
  
      async checkAvailabilityAllowsPlayback(contentItem) {
        if (!contentItem) return false;
  
        const filteredAvailabilitySet = await this.filteredAvailability();
  
        if (!filteredAvailabilitySet.length) {
          return false;
        }
  
        const rentPurchasedActive = await this.getPurchaseListCode(contentItem);
  
        // Get subscriptions from localStorage
        const subscriptionsRaw = localStorage.getItem("subscriptionDetails");
        const subscriptions = subscriptionsRaw ? JSON.parse(subscriptionsRaw) : [];
  
        for (const availability of filteredAvailabilitySet) {
          const priceModel = availability.pricemodel;
  
          if (
            this.subscriberid &&
            (priceModel === "RENTAL" || priceModel === "PAID")
          ) {
            if (rentPurchasedActive) {
              return true;
            }
          } else if (priceModel === "PLAN") {
            if (this.subscriberid && subscriptions.length > 0) {
              for (const subEl of subscriptions) {
                if (subEl?.availabilityset?.includes(availability.availabilityid)) {
                  return true;
                }
              }
            } else if (!subscriptions) {
              // This looks like legacy or edge case, you may want to clarify or remove
              if (this.subscriberid !== this.profileid) {
                return false;
              }
            }
          } else if (priceModel === "FREE") {
            return true;
          }
        }
  
        return false;
      },

      async filteredAvailability() {
          let contentAvailabilitySet = this.content.availabilityset || null;
          let allAvailability = JSON.parse(localStorage.getItem("availabilityList"));
          if(contentAvailabilitySet) {
              const idSet = new Set(contentAvailabilitySet);
              return allAvailability.filter(avail =>
              idSet.has(avail.availabilityid)
              );
          }
          return null;
      },

      async getPurchaseListCode(item) {
        for (let list of this.purchaseListData) {

          if ((list.objectid).toLowerCase() == (item.objectid).toLowerCase()) {
            this.rentPurchasedActive = true;
            this.expireTxt = await this.getFormatedDate(list);

          }
        }
      },

      async getFormatedDate(list) {
        let d = "";
        d = list.expiry
        if (list.expiryafterfirstplay) {
          d = list.expiryafterfirstplay
        }
        function formatAMPM(date) {
          var hours = date.getHours();
          var minutes = date.getMinutes();
          var ampm = hours >= 12 ? 'PM' : 'AM';
          hours = hours % 12;
          hours = hours ? hours : 12; // the hour '0' should be '12'
          minutes = minutes < 10 ? '0' + minutes : minutes;
          var strTime = hours + ':' + minutes + ' ' + ampm;
          return strTime;
        }

        try {
          let newDate = new Date(d);

          newDate.setHours(newDate.getHours() + 5);
          newDate.setMinutes(newDate.getMinutes() + 30);

          return newDate.getDate() + " " + newDate.toLocaleString('default', {
            month: 'short'
          }) + " " + newDate.getFullYear() + ", " + formatAMPM(newDate);
        } catch (e) {
          return d;
        }

      },
    },
    mixins: [],
  };
  </script>
  
  <style lang="scss">
  .lock {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    width: 18%;
    height: 36px;
    align-items: center;
    justify-content: center;
    background: #d31e23;
    border-radius: 0 0.5rem 0 0.5rem;
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .Subscribe {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 26px;
    align-items: center;
    justify-content: center;
    background: #d31e23;
    border-radius: 0.5rem;
    p {
      opacity: 0.9;
    }
  }
  .bottom-18 {
    bottom: 18%;
  }
  </style>
  